/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { useOperativeSystem } from '../../hooks/operative-system';
import { useWindowSize } from '../../hooks/window-size';
import { makeTooltipContainer, makeTooltipArrow, makeTooltipMessage } from './mixins';
const TooltipContainer = styled.div `
  ${(props) => makeTooltipContainer(props)}
`;
export const TooltipArrow = styled.div `
  ${(props) => makeTooltipArrow(props)}
`;
export const TooltipMessage = styled.div `
  ${(props) => makeTooltipMessage(props)}
`;
export const Tooltip = ({ children = 'Tooltip sin contenido', toggleElement, position = 'bottom', align = 'center', width = '300', background = 'white', color = 'black', showMobile = false, }) => {
    const [show, setShow] = useState(false);
    const { isDesktop } = useWindowSize();
    const { isMobileOS } = useOperativeSystem();
    const [toggleParams, setToggleParams] = useState({});
    const tooltipRef = useRef(null);
    const timeoutRef = useRef(null);
    const setToggle = () => {
        var _a;
        const domRects = (_a = toggleElement === null || toggleElement === void 0 ? void 0 : toggleElement.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        setToggleParams(domRects || {});
    };
    const showTooltip = () => {
        setToggle();
        setShow(true);
    };
    const hideTooltip = () => {
        setShow(false);
    };
    const tapTooltip = () => {
        if (show) {
            hideTooltip();
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        }
        else {
            showTooltip();
            timeoutRef.current = setTimeout(() => {
                hideTooltip();
                timeoutRef.current = null;
            }, 2000);
        }
    };
    const setListeners = () => {
        if (toggleElement === null || toggleElement === void 0 ? void 0 : toggleElement.current) {
            toggleElement.current.onmouseenter = () => showTooltip();
            toggleElement.current.onmouseleave = () => hideTooltip();
        }
    };
    const unsetListeners = () => {
        if (toggleElement === null || toggleElement === void 0 ? void 0 : toggleElement.current) {
            toggleElement.current.onmouseenter = () => { };
            toggleElement.current.onmouseleave = () => { };
        }
    };
    useEffect(() => {
        setToggle();
        setListeners();
        return () => {
            unsetListeners();
        };
    }, []);
    useEffect(() => {
        if (showMobile && !isDesktop) {
            if (toggleElement === null || toggleElement === void 0 ? void 0 : toggleElement.current) {
                toggleElement.current.onclick = () => tapTooltip();
            }
        }
        return () => {
            if (toggleElement === null || toggleElement === void 0 ? void 0 : toggleElement.current) {
                toggleElement.current.onclick = () => { };
            }
        };
    }, [show]);
    const renderArrow = () => {
        const d = 'M6.26795 1C7.03775 -0.333332 8.96225 -0.333334 9.73205 0.999999L14.9282 10C15.698 11.3333 14.7358 13 13.1962 13L2.80385 13C1.26425 13 0.301996 11.3333 1.0718 10L6.26795 1Z';
        return (React.createElement("svg", { width: "16", height: "13", viewBox: "0 0 16 13", fill: background, xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: d, fill: background })));
    };
    if (showMobile || (!isMobileOS && isDesktop)) {
        return ReactDOM.createPortal(React.createElement(TooltipContainer, { ref: tooltipRef, position: position, align: align, toggleParams: toggleParams, tooltipParams: tooltipRef.current && tooltipRef.current.getBoundingClientRect(), className: show ? 'visible' : '' },
            React.createElement(TooltipArrow, { position: position, align: align, toggleParams: toggleParams, tooltipParams: tooltipRef.current && tooltipRef.current.getBoundingClientRect(), width: width }, renderArrow()),
            React.createElement(TooltipMessage, { width: width, background: background, color: color }, children)), document.getElementById('floating-elements'));
    }
    return null;
};
